import * as v from 'valibot';

import { HttpResponse } from 'msw';

export const PropertyError = <T extends readonly string[]>(keys: T) =>
	v.object({
		propertyName: v.picklist(keys),
		errorMessage: v.string(),
	});

export const GeneralError = v.object({
	errorMessage: v.string(),
});

export const TransactionResult = <T extends readonly string[]>(keys: T) =>
	v.object({
		propertyErrors: v.nullish(v.array(PropertyError(keys))),
		generalError: v.nullish(GeneralError),
	});

export const makeErrors = function <T extends object>(
	addErrors: (
		propertyErrors: Array<{
			propertyName: keyof T;
			errorMessage: string;
		}>,
	) => void,
	generalError?: string,
): HttpResponse<TransactionResult<T>> {
	const propertyErrors: Array<{
		propertyName: keyof T;
		errorMessage: string;
	}> = [];

	addErrors(propertyErrors);

	return HttpResponse.json(
		{
			generalError: generalError ? { errorMessage: generalError } : undefined,
			propertyErrors,
		} satisfies TransactionResult<T>,
		{
			status: 400,
		},
	);
};

export type TransactionResult<T> = {
	propertyErrors?: Array<{
		propertyName: keyof T;
		errorMessage: string;
	}> | null;
	generalError?: {
		errorMessage: string;
	} | null;
};

export class TransactionError<T> extends Error {
	constructor(public result: TransactionResult<T>) {
		super('API Errors');
	}
}
